import type { FC } from 'react';

interface HelpFullTemplateProps {}

export const HelpFullTemplate: FC<HelpFullTemplateProps> = () => {
  return (
    <>
      {/* todo: add Help title page using hr tag */}
      <header style={{ padding: '1em' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {isSafari ? (
            <div
              style={{
                marginTop: '10px',
                fontSize: '14px',
                color: '#333333',
                backgroundColor: '#fff2c9',
                padding: '10px',
                borderRadius: '5px',
                boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
              }}
            >
              <p>You are using Safari browser. For the better PDF quality, please use Google Chrome.</p>
            </div>
          ) : null}

          <button
            style={{
              backgroundColor: '#007bff',
              color: 'white',
              marginTop: '1em',
              padding: '10px 20px',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              border: 'none',
            }}
            onClick={handlePrint}
          >
            Save as PDF
          </button>
        </div>
      </header>
    </>
  );
};

// Utils
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

const handlePrint = (): void => {
  if (isSafari) {
    alert('Safari detected. Please use the browser\'s print functionality: \'Right click/Print Frame...\'');
  } else {
    window.print();
  }
};
